import DataTable from "../../../Components/DataTable/DataTable";
import { FlagOutlined, SoundOutlined, WarningFilled } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import { Button, Input, Modal, Select, Tag, message } from "antd";
import VoiceRecorder from "../../../Components/VoiceRecorder/VoiceRecorder";
import Skills from "../Skills/Skills";
import FlagMapper from "../../../Util/FlagMapper";
import api from "../../../api/api";
import * as actions from "../../../store/actions/action";
import { connect } from "react-redux";
import { editError, submitError } from "../../../Util/Messages";
import CheckPermission from "../../../Util/CheckPermission";
import { useNavigate } from "react-router-dom";
import ExportExcel from "../../../Util/ExportExcel";
import { toJalaali } from "jalaali-js";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const Flags = (props) => {
  const {
    LoadingSetter,
    loading,
    loadIds,
    ClearLoading,
    permissions,
    rowSelection,
    flagsData,
    skillsData,
    loadAll = false,
    role,
  } = props;
  const [openModal, setOpenModal] = useState(false);
  const [flagsTag, setFlagsTag] = useState([]);
  const [flagsCategory, setFlagsCategory] = useState([]);
  const [flagsConnectionReport, setFlagsConnectionReport] = useState([]);
  const [openPostConditionFlagsModal, setOpenPostConditionFlagsModal] =
    useState(false);
  const [openPreConditionFlagsModal, setOpenPreConditionFlagsModal] =
    useState(false);
  const [openVoiceModal, setOpenVoiceModal] = useState(false);
  const [voiceFlag, setVoiceFlag] = useState(null);
  const [editingRecord, setEditingRecord] = useState();
  const [editableKeys, setEditableRowKeys] = useState();
  const [data, setData] = useState([]);
  const [flagsStat, setFlagStat] = useState([]);
  const [pagination, setPagination] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    console.log({ editingRecord });
  }, [editingRecord]);

  const hideSomeColumns = role == null || role == "flags_editor";

  const FlagTypes = [
    { value: "work", text: "شغل" },
    { value: "education", text: "تحصیل" },
    { value: "health", text: "سلامتی" },
    { value: "relation", text: "روابط" },
    { value: "self-knowing", text: "خودشناسی" },
    { value: "action", text: "اقدامک" },
    { value: "experience", text: "ارتقای دانش و مهارت" },
    { value: "self-awareness", text: "تحصیل و دانشگاه" },
    { value: "discovery", text: "مهارت‌های پایه" },
    { value: "preparation", text: "تجربه شغلی" },
    { value: "professional", text: "حرفه‌ای سازی و رشد" },
  ];
  const displayTypes = [
    { value: false, text: "نمایش" },
    { value: true, text: "عدم نمایش" },
  ];
  const columns = [
    {
      title: "نوع",
      dataIndex: "type",
      filters: FlagTypes,
      hideInTable: hideSomeColumns,
      onFilter: (value, record) => {
        return record.type ? record?.type?.includes(value) : true;
      },
      width: "8%",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select>
              {(FlagTypes ?? [])?.map((el) => {
                return (
                  <Select.Option value={el.value} key={el.value}>
                    {el.text}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (text, row) => <div>{FlagMapper(text)?.title}</div>,
    },
    {
      title: " نام کارت",
      dataIndex: "title",
      searchable: true,
      renderFormItem: () => <Input.TextArea autoSize />,
    },
    // connected
    {
      title: "متصل به سوال",
      // filters: [
      //   { value: true, text: "متصل" },
      //   { value: false, text: "غیر متصل" },
      // ],
      // onFilter: (val, row) => {
      //   return flagsConnectionReport.includes(row.id) === val;
      // },
      renderFormItem: () => "-",
      render: (_, row) => {
        const exists = flagsConnectionReport.includes(row.id);

        if (exists) return <CheckCircleIcon style={{ color: "#1677ff" }} />;
        return <ErrorIcon style={{ color: "red" }} />;
      },
    },
    // hidden
    {
      title: "نمایش در نقشه راه",
      dataIndex: "hidden",
      hideInTable: hideSomeColumns,

      filters: displayTypes,
      onFilter: (value, record) => {
        if (record.hidden) {
          return value === record.hidden;
        }
        if (value === false) {
          return true;
        }
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select defaultValue={record.hidden ? false : record.hidden}>
              {(displayTypes ?? [])?.map((el) => (
                <Select.Option value={el.value} key={el.value}>
                  {el.text}
                </Select.Option>
              ))}
            </Select>
          );
        }
      },
      render: (text, row) => {
        let newText = "";
        displayTypes.forEach((el) => {
          if (el.value === text) {
            newText = el.text;
          }
        });
        if (!row.hidden) {
          newText = "نمایش";
        }
        return <div>{newText}</div>;
      },
    },
    // category
    {
      title: "دسته بندی",
      dataIndex: "flagCategory",
      hideInTable: hideSomeColumns,
      disableLocalSearch: true,
      filters: (flagsCategory ?? [])?.map((category) => ({
        value: category,
        text: category,
      })),
      onFilter: (value, record) => {
        return record?.flagCategory?.indexOf(value) !== -1;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select
              mode="tags"
              allowClear
              style={{ width: "100%" }}
              placeholder="دسته بندی کارت"
            >
              {(flagsCategory ?? [])?.map((category) => (
                <Select.Option key={category} value={category}>
                  {category}
                </Select.Option>
              ))}
            </Select>
          );
        }
      },
      render: (_, row) => {
        if (row?.flagCategory?.length === 0) {
          return (
            <div>
              <WarningFilled />
              <span style={{ marginRight: "0.25rem" }}>بدون دسته بندی</span>
            </div>
          );
        }
        return (row?.flagCategory ?? [])?.map((el) => (
          <Tag style={{ margin: "0.25rem" }}>{el}</Tag>
        ));
      },
    },
    // description
    {
      title: "توضیحات",
      dataIndex: "description",
      searchable: true,
      width: "15%",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return <Input.TextArea autoSize />;
        }
      },
      render: (text, row) => {
        if (`${text}`.length < 10) {
          return (
            <div>
              <span> {text} </span>
              <span>
                (<WarningFilled /> متن کمتر از ۱۰ کارکتر است)
              </span>
            </div>
          );
        }
        return text;
      },
    },
    // voice
    {
      title: "صدا",
      dataIndex: "voiceUrl",
      width: "10%",
      editable: false,
      render: (voiceUrl, row) => (
        <Button
          icon={<SoundOutlined />}
          type={voiceUrl ? "primary" : "default"}
          onClick={() => {
            setVoiceFlag(row);
            setOpenVoiceModal(true);
          }}
        >
          {voiceUrl ? "ویرایش" : "افزودن"}
        </Button>
      ),
    },
    // flag tags
    {
      title: "تگ",
      dataIndex: "flagTag",
      hideInTable: hideSomeColumns,
      filters: (flagsTag ?? [])?.map((el) => ({ value: el, text: el })),
      onFilter: (value, record) => {
        return record?.flagTag?.indexOf(value) !== -1;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select
              defaultValue={record.flagTag}
              mode="tags"
              allowClear
              style={{ width: "100%" }}
              placeholder="تگ کارت"
            >
              {(flagsTag ?? [])?.map((tag) => (
                <Select.Option key={tag} value={tag}>
                  {tag}
                </Select.Option>
              ))}
            </Select>
          );
        }
      },
      render: (tags) => {
        if (!Array.isArray(tags) || tags?.length === 0) {
          return (
            <div>
              <WarningFilled /> کارت بدون تگ است.
            </div>
          );
        }
        return (
          tags?.map((el) => <Tag style={{ margin: "0.25rem" }}>{el}</Tag>) ??
          "-"
        );
      },
    },
    // pre flags
    {
      title: "کارت‌های پیش نیاز",
      dataIndex: "preConditionFlagsText",
      searchable: true,
      hideInTable: hideSomeColumns,
      // filterSearch: true,
      // filters: data?.map((fl) => ({ text: fl.title, value: fl.id })) ?? [],
      // onFilter: (value, record) => {
      //   return record.preConditionFlags.find((el) => el.id == value);
      // },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <div>
              {Array.isArray(record.preConditionFlags)
                ? record?.preConditionFlags?.map((el) => (
                    <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
                  ))
                : null}
              <Button
                onClick={() => {
                  setOpenPreConditionFlagsModal(true);
                  setEditingRecord(record);
                }}
              >
                انتخاب
              </Button>
            </div>
          );
        }
      },
      render: (flagsArray, row) => {
        if (Array.isArray(flagsArray)) {
          if (flagsArray.length === 0) {
            return (
              <div>
                <WarningFilled /> کارت بدون پیش نیاز است.
              </div>
            );
          }
          return flagsArray?.map((el) => (
            <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
          ));
        }
      },
    },
    // post flags
    {
      title: "کارت‌های پس نیاز",
      dataIndex: "postConditionFlagsText",
      hideInTable: hideSomeColumns,
      searchable: true,
      // filterSearch: true,
      // filters: data?.map((fl) => ({ text: fl.title, value: fl.id })) ?? [],
      // onFilter: (value, record) => {
      //   return record?.postConditionFlags?.find((el) => el.id == value);
      // },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <div>
              {Array.isArray(record?.postConditionFlags)
                ? record?.postConditionFlags?.map((el) => (
                    <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
                  ))
                : null}
              <Button
                onClick={() => {
                  setOpenPostConditionFlagsModal(true);
                  setEditingRecord(record);
                }}
              >
                انتخاب
              </Button>
            </div>
          );
        }
      },
      render: (flagsArray, row) => {
        if (Array.isArray(flagsArray)) {
          if (flagsArray.length === 0) {
            return (
              <div>
                <WarningFilled /> کارت بدون پس نیاز است.
              </div>
            );
          }
          return flagsArray.map((el) => (
            <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
          ));
        }
      },
    },
    // flag skills
    {
      title: "مهارت‌ها",
      dataIndex: "skillsText",
      hideInTable: hideSomeColumns,
      searchable: true,
      // filters:
      //   Array.isArray(skillsData) &&
      //   (skillsData?.map((skill) => {
      //     return {
      //       value: skill.title,
      //       text: skill.title,
      //     };
      //   }) ??
      //     []),
      // filterSearch: true,
      // onFilter: (value, record) => {
      //   if (Array.isArray(record.skills)) {
      //     let has = false;
      //     record?.skills?.forEach((el) => {
      //       // console.log(el)
      //       if (el.title === value) {
      //         has = true;
      //       }
      //     });
      //     return has;
      //   }
      // },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <div>
              {Array.isArray(record.skills)
                ? record.skills.map((el) => (
                    <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
                  ))
                : null}
              <Button
                onClick={() => {
                  setOpenModal(true);
                  setEditingRecord(record);
                }}
              >
                انتخاب
              </Button>
            </div>
          );
        }
      },
      render: (skillsArray, row) => {
        if (Array.isArray(skillsArray)) {
          if (skillsArray.length === 0) {
            return (
              <div>
                <WarningFilled /> کارت بدون مهارت است.
              </div>
            );
          }
          return skillsArray.map((el) => (
            <Tag style={{ margin: "0.25rem" }}>{el.title}</Tag>
          ));
        }
      },
    },
    {
      title: "تاریخ ساخت ",
      width: "8%",
      align: "center",
      dataIndex: "createdAt",
      editable: false,
      hideInTable: hideSomeColumns,
      sorter: (a, b) => {
        const Adate = new Date(a.createdAt);
        const Bdate = new Date(b.createdAt);

        return Bdate - Adate;
      },
      render: (text, record) => {
        const date = text ? new Date(text) : new Date();
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate(),
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("eo", { hour12: false })}
          </span>
        );
      },
    },
  ];

  const getFlagSta = (flagId) => {
    const flag = flagsStat.find((flag) => flag.id === flagId);

    return {
      total: flag?.totalCount ?? -1,
      term1: flag?.term1 ?? -1,
      term2: flag?.term2 ?? -1,
      term3: flag?.term3 ?? -1,
      term4: flag?.term4 ?? -1,
    };
  };
  const lastQueryRef = useRef({ page: 1, pageSize: 100, filters: {} });

  const loadData = (page = 1, pageSize = 100, filters = {}) => {
    lastQueryRef.current = { page, pageSize, filters };
    api
      .get("/flags", {
        params: {
          page: loadAll ? 1 : page,
          pageSize: loadAll ? 9999 : pageSize,
          filters,
          ...(loadIds ? { includes: loadIds } : {}),
          // include: rowSelection?.selectedRowKeys ?? [],
        },
      })
      .then((res) => {
        console.log({ res: res.data.data });
        setData(
          res.data.data.map((e) => ({
            ...e,

            postConditionFlagsText: e.postConditionFlags
              .map((el) => el.title)
              .join(" - "),
            preConditionFlagsText: e.preConditionFlags
              .map((el) => el.title)
              .join(" - "),
            skillsText: e.skills.map((el) => el.title).join(" - "),
          })),
        );
        setPagination(res.data.pagination);
      });
  };
  const getFlagCategories = () => {
    api
      .get("/flags/category")
      .then((res) =>
        setFlagsCategory(res?.data?.filter((e) => e && e?.trim() !== "") ?? []),
      )
      .catch(() => message.error("خطا در دریافت دسته بندی ها"));
  };
  const removeSkillHandler = (record) => {
    const newData = data;
    const newRecord = editingRecord;
    const skillsArray = newRecord.skills;
    let index = null;
    newRecord.skills.forEach((skill, i) => {
      if (skill.id === record.id) {
        index = i;
      }
    });
    skillsArray.splice(index, 1);
    newRecord.skills = skillsArray;
    const finalData = newData.map((el) => {
      if (el.id === newRecord.id) {
        return newRecord;
      }
      return el;
    });

    setData(finalData);
  };
  const onSelectSkillHandler = (record, selected) => {
    const newData = data;
    const newRecord = editingRecord;
    if (selected) {
      newRecord.skills.push(record);
      const finalData = newData.map((el) => {
        if (el.id === newRecord.id) {
          return newRecord;
        }
        return el;
      });
      setData(finalData);
    } else {
      removeSkillHandler(record);
    }
  };
  const removeFlagHandler = (record, field) => {
    const newData = data;
    const newRecord = editingRecord;
    const flags = newRecord[field];
    let index = null;
    flags.forEach((flag, i) => {
      if (flag.id === record.id) {
        index = i;
      }
    });
    newRecord[field].splice(index, 1);
    const finalData = newData.map((el) => {
      if (el.id === newRecord.id) {
        return newRecord;
      }
      return el;
    });
    setData(finalData);
  };
  const onSelectFlagHandler = (record, selected, field) => {
    const newData = data;
    const newRecord = editingRecord;
    if (selected) {
      newRecord[field].push(record);
      const finalData = newData.map((el) => {
        if (el.id === newRecord.id) {
          return newRecord;
        }
        return el;
      });
      setData(finalData);
    } else {
      removeFlagHandler(record, field);
    }
  };
  const flagConnectionHandler = (rowData, oldData, field) => {
    console.log(rowData[field], oldData[field]);
    const endPoint = field.substring(0, field.length - 1);
    const isPre = field === "preConditionFlags";
    if (Array.isArray(rowData[field])) {
      const removes = oldData[field]
        .map((el) => {
          let removed = true;
          rowData[field].forEach((a) => {
            if (el.id === a.id) {
              removed = false;
            }
          });
          if (removed) {
            return el;
          }
          return null;
        })
        .filter(function (el) {
          return el != null;
        });
      const adds = rowData[field]
        .map((el) => {
          let added = true;
          oldData[field].forEach((a) => {
            if (el.id === a.id) {
              added = false;
            }
          });
          if (added) {
            return el;
          }
          return null;
        })
        .filter(function (el) {
          return el != null;
        });
      if (Array.isArray(removes)) {
        let counter = 0;
        const req = () => {
          const remove = removes[counter];
          if (remove) {
            let data = null;
            if (isPre) {
              data = {
                preFlagId: remove.id,
                mainFlagId: oldData.id,
              };
            } else {
              data = {
                postFlagId: remove.id,
                mainFlagId: oldData.id,
              };
            }
            api
              .post(`relations/remove${endPoint}`, { data })
              .then(() => {
                if (counter === removes.length - 1) {
                  ClearLoading();
                } else {
                  counter++;
                  req();
                }
              })
              .catch(() => {
                ClearLoading();
                editError();
              });
          }
        };
        req();
      }
      if (Array.isArray(adds)) {
        let counter = 0;
        const req = () => {
          const add = adds[counter];
          if (add) {
            let data = null;
            if (isPre) {
              data = {
                preFlagId: add.id,
                mainFlagId: oldData.id,
              };
            } else {
              data = {
                postFlagId: add.id,
                mainFlagId: oldData.id,
              };
            }
            api
              .post(`relations/${endPoint}`, { data })
              .then(() => {
                if (counter === adds.length - 1) {
                  ClearLoading();
                } else {
                  counter++;
                  req();
                }
              })
              .catch(() => {
                ClearLoading();
                editError();
              });
          }
        };
        req();
      }
    } else {
      ClearLoading();
    }
  };
  const skillConnectionsHandler = (rowData, oldData) => {
    const removes = oldData.skills.map((el) => {
      let removed = true;
      // console.log(el)
      rowData.skills.forEach((a) => {
        if (el.id === a.id) {
          removed = false;
        }
      });
      return removed ? el : null;
    });
    const adds = rowData.skills.map((el) => {
      let added = true;
      // console.log(el)
      oldData.skills.forEach((a) => {
        if (el.id === a.id) {
          added = false;
        }
      });
      return added ? el : null;
    });
    if (Array.isArray(removes)) {
      removes.forEach((removed, index) => {
        if (removed) {
          api
            .post("/relations/removeflagtoskill", {
              data: { flagId: oldData.id, skillId: removed.id },
            })
            .then(() => {
              if (index === removes.length - 1) {
                ClearLoading();
              }
            })
            .catch(() => {
              if (index === removes.length - 1) {
                ClearLoading();
                editError();
              }
            });
        }
      });
    }
    if (Array.isArray(adds)) {
      adds.forEach((add, index) => {
        if (add) {
          api
            .post("/relations/flagtoskill", {
              data: { flagId: oldData.id, skillId: add.id },
            })
            .then(() => {
              if (index === removes.length - 1) {
                ClearLoading();
              }
            })
            .catch(() => {
              if (index === removes.length - 1) {
                ClearLoading();
                editError();
              }
            });
        }
      });
    }
  };
  const getFlagsTag = () => {
    api
      .get("/flags/tags")
      .then((res) =>
        setFlagsTag(res?.data?.filter((e) => e && e?.trim() !== "") ?? []),
      )
      .catch(() => message.error("خطا در دریافت تگ ها"));
  };
  const loadFlagsReport = () => {
    api.get("/flags/report").then(({ data }) => {
      if (role != null && role != "flags_editor") {
        setFlagStat(data.data);
      }
      setFlagsConnectionReport(data.connectedFlagsInAllForms);
    });
  };
  const deleteFromData = (id) => {
    setData((prev) => prev.filter((e) => e.id !== id));
  };
  const newFlagValidation = (rowData) => {
    if (
      (!rowData.description || `${rowData.description}`.trim() === "") &&
      rowData.hidden !== true
    ) {
      message.error(
        "کارتی که در نقشه راه نمایش داده می‌شود نمی‌تواند توضیحات نداشته باشد.",
      );
      return false;
    }
    if (!rowData.title || `${rowData.title}`.trim() === "") {
      message.error("نام کارت خالی است.");
      return false;
    }
    return true;
  };
  const onSave = (row, rowData) => {
    if (!newFlagValidation(rowData)) {
      const { page, pageSize, filters } = lastQueryRef.current;
      loadData(page, pageSize, filters);
      return;
    }
    let oldData = null;
    [...data].forEach((item) => {
      if (item.id === row.id) {
        oldData = item;
      }
    });
    LoadingSetter();
    if (
      oldData === null ||
      typeof rowData.id == "undefined" ||
      !Number.isInteger(rowData.id)
    ) {
      api
        .post("/flags", {
          data: {
            title: rowData.title,
            flagTag: rowData.flagTag ?? [],
            flagCategory: rowData.flagCategory ?? [],
            description: rowData.description ? rowData.description : "-",
            type: rowData.type,
            hidden: rowData.hidden ?? false,
            personal: false,
          },
        })
        .then((res) => {
          oldData = {
            ...res.data,
            skills: [],
            preConditionFlags: [],
            postConditionFlags: [],
          };
          rowData.id = res.data.id;

          if (Array.isArray(rowData.skills)) {
            skillConnectionsHandler(rowData, oldData);
          }
          if (Array.isArray(rowData.preConditionFlags)) {
            flagConnectionHandler(rowData, oldData, "preConditionFlags");
          }
          if (Array.isArray(rowData.postConditionFlags)) {
            flagConnectionHandler(rowData, oldData, "postConditionFlags");
          }

          ClearLoading();
        })
        .catch(() => {
          deleteFromData(row.id);
          ClearLoading();
          submitError();
        });
    } else {
      api
        .put("/flags/" + oldData.id, {
          data: {
            title: rowData.title,
            flagTag: rowData.flagTag ?? [],
            flagCategory: rowData.flagCategory ?? [],
            description: rowData.description ? rowData.description : "-",
            type: rowData.type,
            hidden: rowData.hidden ?? false,
            personal: rowData.personal ? rowData.personal : false,
          },
        })
        .then((res) => {
          ClearLoading();
        })
        .catch(() => {
          ClearLoading();
          editError();
        });
      api
        .get(`/flags/${oldData.id}`)
        .then((res) => {
          ClearLoading();
          oldData = res.data;
          if (Array.isArray(rowData.skills)) {
            skillConnectionsHandler(rowData, oldData);
          }
          if (Array.isArray(rowData.preConditionFlags)) {
            flagConnectionHandler(rowData, oldData, "preConditionFlags");
          }
          if (Array.isArray(rowData.postConditionFlags)) {
            flagConnectionHandler(rowData, oldData, "postConditionFlags");
          }

          ClearLoading();
        })
        .catch(() => {
          ClearLoading();
          editError();
        });
    }
    setTimeout(() => {
      ClearLoading();
    }, 3000);

    // console.log(oldData , 'new data status')
  };
  const exportData = () => {
    const json = flagsData.map((flag) => {
      const report = getFlagSta(flag.id);
      const flagObj = {
        نوع: FlagMapper(flag.type).title,
        "نام کارت": flag.title,
        "نمایش در نقشه راه": flag.hidden ? "عدم نمایش" : "نمایش",
        تگ: flag.flagTag.join(" - "),
        "دسته بندی": flag.flagCategory.join(" - "),
        توضیحات: flag.description,

        "تعداد در ستون اول": report.term1,
        "تعداد در ستون دوم": report.term2,
        "تعداد در ستون سوم": report.term3,
        "تعداد در ستون چهارم": report.term4,
        "تعداد در مجموع ستون ها": report.total,
      };
      flag.skills.forEach((skill, index) => {
        flagObj[`مهارت${index + 1}`] = skill.title;
      });
      flag.preConditionFlags.forEach((preFlag, index) => {
        flagObj[`کارت پیش نیاز${index + 1}`] = preFlag.title;
      });
      flag.postConditionFlags.forEach((postFlag, index) => {
        flagObj[`کارت پس نیاز${index + 1}`] = postFlag.title;
      });
      return flagObj;
    });
    ExportExcel(json, "کارت‌ها");
  };
  const filtersBeautify = (fData) => {
    console.log({ fData });

    return {
      ...(fData.type?.at(0) ? { types: fData.type } : {}),
      ...(fData.flagTag?.at(0) ? { tags: fData.flagTag } : {}),
      ...(fData.flagCategory?.at(0) ? { categories: fData.flagCategory } : {}),
      ...(fData.title?.at(0) ? { title: fData.title?.at(0) } : {}),
      ...(fData.description?.at(0) ? { title: fData.description?.at(0) } : {}),
      ...(fData.hidden?.at(0) ? { hidden: fData.hidden?.at(0) } : {}),
      ...(fData.postConditionFlagsText?.at(0)
        ? { postFlag: fData.postConditionFlagsText?.at(0) }
        : {}),
      ...(fData.preConditionFlagsText?.at(0)
        ? { preFlag: fData.preConditionFlagsText?.at(0) }
        : {}),
      ...(fData.skillsText?.at(0) ? { skill: fData.skillsText?.at(0) } : {}),
    };
  };

  useEffect(() => {
    if (role != null && role != "flags_editor") {
      setTimeout(() => {
        getFlagCategories();
        getFlagsTag();
      }, 2000);
    }
  }, [data]);

  useEffect(() => {
    loadData();
    loadFlagsReport();
  }, []);

  useEffect(() => {
    if (
      permissions !== null &&
      CheckPermission("flags_list", permissions) === false
    ) {
      navigate("/permissionDenied");
    }
  }, [permissions]);

  return (
    <div>
      <DataTable
        showSupervisorFilter={true}
        dynamicPagination
        filtersBeautify={filtersBeautify}
        recordsCount={pagination?.total}
        header={{
          title: "کارت‌ها",
          avatar: { icon: <FlagOutlined />, size: "large" },
          extra: CheckPermission("export_excel", permissions) && (
            <Button onClick={exportData}>خروجی اکسل</Button>
          ),
        }}
        editable
        keepPageOnSave
        userRole={role}
        onReset={loadData}
        onSave={onSave}
        columns={columns}
        dataSource={data}
        hideComment={hideSomeColumns}
        hideErrorReport={hideSomeColumns}
        recordDefault={{
          skills: [],
          postConditionFlags: [],
          preConditionFlags: [],
          hidden: false,
          createdAt: new Date().toString(),
        }}
        setDataSource={setData}
        editableKeys={editableKeys}
        reload={loadData}
        path="/flags"
        setEditableRowKeys={setEditableRowKeys}
        permissionsPrefix="flags"
        rowSelection={rowSelection}
        rowClassName={(record) => {
          if (Array.isArray(record.skills)) {
            if (`${record.description}`.length < 10 && !record.hidden) {
              return "row_error";
            }
            if (
              record === null ||
              typeof record.id == "undefined" ||
              !Number.isInteger(record.id)
            ) {
              return "row_error";
            }
            if (record.skills.length === 0) {
              if (record.hidden) {
                return "row_error";
              }
              return "row_warning";
            }
          }
        }}
      />

      <Modal
        destroyOnClose
        centered
        width="100%"
        open={openModal}
        onOk={() => {
          setOpenModal(false);
        }}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Skills
          loadAll={true}
          rowSelection={{
            hideSelectAll: true,
            onSelect: onSelectSkillHandler,
            selectedRowKeys: editingRecord
              ? (editingRecord.skills ?? []).map((skill) => {
                  return skill.id;
                })
              : null,
            getCheckboxProps: (record) => ({
              disabled:
                [...record.ways].length === 0 ||
                record.supervisorConfirm === false,
              name: record.name,
            }),
          }}
        />
      </Modal>

      {/* post condition */}
      <Modal
        destroyOnClose
        centered
        width="100%"
        open={openPostConditionFlagsModal}
        onOk={() => {
          setOpenPostConditionFlagsModal(false);
        }}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Flags
          {...props}
          loadAll={true}
          loadIds={editingRecord?.postConditionFlags?.map((e) => e.id)}
          rowSelection={{
            hideSelectAll: true,
            onSelect: (record, selected) => {
              onSelectFlagHandler(record, selected, "postConditionFlags");
            },
            selectedRowKeys: editingRecord
              ? editingRecord.postConditionFlags.map((flag) => {
                  return flag.id;
                })
              : null,
            getCheckboxProps: (record) => ({
              disabled: record.id === editingRecord.id,
              name: record.name,
            }),
          }}
        />
      </Modal>

      {/* voice modal */}
      <Modal
        destroyOnClose
        centered
        width={500}
        open={openVoiceModal}
        title={`صدای کارت${voiceFlag?.title ? `: ${voiceFlag.title}` : ""}`}
        onCancel={() => {
          setOpenVoiceModal(false);
          setVoiceFlag(null);
        }}
        onOk={() => {
          setOpenVoiceModal(false);
          setVoiceFlag(null);
        }}
      >
        {voiceFlag && (
          <VoiceRecorder
            key={voiceFlag.id}
            initialMedia={
              voiceFlag.voiceUrl ? { url: voiceFlag.voiceUrl } : null
            }
            onChange={(field, value) => {
              if (field !== "voiceUrl") return;
              const newUrl = value || null;
              api
                .patch(`/flags/${voiceFlag.id}/voice`, { voiceUrl: newUrl })
                .then(() => {
                  message.success(newUrl ? "صدا ذخیره شد" : "صدا حذف شد");
                  setData((prev) =>
                    prev.map((r) =>
                      r.id === voiceFlag.id ? { ...r, voiceUrl: newUrl } : r,
                    ),
                  );
                  setVoiceFlag((prev) =>
                    prev ? { ...prev, voiceUrl: newUrl } : prev,
                  );
                })
                .catch(() => message.error("خطا در ذخیره صدا"));
            }}
          />
        )}
      </Modal>

      {/* pre condition */}
      <Modal
        destroyOnClose
        centered
        width="100%"
        open={openPreConditionFlagsModal}
        onOk={() => {
          setOpenPreConditionFlagsModal(false);
        }}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Flags
          loadAll={true}
          loadIds={editingRecord?.preConditionFlags?.map((e) => e.id)}
          {...props}
          rowSelection={{
            hideSelectAll: true,
            onSelect: (record, selected) => {
              onSelectFlagHandler(record, selected, "preConditionFlags");
            },
            selectedRowKeys: editingRecord
              ? editingRecord.preConditionFlags.map((flag) => {
                  return flag.id;
                })
              : null,
            getCheckboxProps: (record) => ({
              disabled: record.id === editingRecord.id,
              name: record.name,
            }),
          }}
        />
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
    // flagsData: state.flags,
    // skillsData: state.skills,
    role: state.userData ? state.userData.role : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
    // loadData: () => dispatch(actions.getDatabase()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Flags);
